var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-item",style:(`left: ${_vm.startPosition}%; width: ${_vm.timelineWidth}%; background-color: ${_vm.vehicle.color}`)})
}
var staticRenderFns = []

export { render, staticRenderFns }